import * as qs from 'query-string';
import { Component } from 'react';
import { SwapManagementAction } from './swap-managerment-action';
import { connect, Dispatch } from "react-redux";
import { AppActionCreators, IApplicationState, IAppState, IAvailableRecipientListResponse, IAvailableRecipient, SwapActionCreators, IAdminNotificationResponse, AdminActionCenterActionCreators } from "@nkr/store/index";
import { IAdminNotification, IBaseResponse, ICenterBase, IClusterListResponse, IPosition } from '@nkr/models/index';
import SwapManagement from '.';
import { toast } from 'react-toastify';
import { Col, Row, Well } from 'react-bootstrap';

interface IOwnProps {
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getSwapsByChainId: (chainId: number) => Promise<IClusterListResponse>,
    getAvailableRecipients: () => Promise<IAvailableRecipientListResponse>,
    getNotification: (id: number) => Promise<IAdminNotificationResponse>,
    bridgeDonor: (donorId: number, chainId: number) => Promise<IBaseResponse>,
    unBridgeDonor: (donorId: number, chainId: number) => Promise<IBaseResponse>,
    convertToVoucher: (donorId: number, originalChainId: number, newChainId: number) => Promise<IBaseResponse>,
    cancelCluster: (clusterId: number, firstDonorId: number) => Promise<IBaseResponse>,
    removeRecipientFromCluster: (clusterId: number, recipientId: number) => Promise<IBaseResponse>,
    removePairFromCluster: (clusterId: number, positionNumber: number, recipientId: number, bridgeDonorId: number) => Promise<IBaseResponse>,
    replaceRecipientInCluster: (clusterId: number, recipientId: number, replacementRecipientId: number, bridgeDonorId: number) => Promise<IBaseResponse>,
    replacePairInCluster: (clusterId: number, currentBridgeDonorId: number, replacementRecipientId: number, bridgeDonorId: number) => Promise<IBaseResponse>,
    addRecipientToCluster: (clusterId: number, positionNumber: number, recipientId: number, bridgeDonorId: number) => Promise<IBaseResponse>,
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    chainId: number,
    clusterNumber: number,
    positionNumber: number,
    positions: IPosition[],
    availableRecipients: IAvailableRecipient[],
    availableRecipientCenterList: ICenterBase[],
    notification: IAdminNotification
}

class SwapManagementPage extends Component<TProps, IState> {
    readonly state: IState = {
        chainId: 0,
        clusterNumber: 0,
        positionNumber: 0,
        positions: [],
        availableRecipients: [],
        availableRecipientCenterList: [],
        notification: null
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let parsed = qs.parse(window.location.search);
        let chainId = parsed.chain != null ? parseInt(parsed.chain) : 0;
        let clusterNumber = parsed.cluster != null ? parseInt(parsed.cluster) : 0;
        let positionNumber = parsed.position != null ? parseInt(parsed.position) : 0;
        let notificationId = parsed.notification != null ? parseInt(parsed.notification) : 0;

        this.props.showLoading('Getting chain information, one moment please...').then(async () => {
            let availableRecipientResponse = await this.props.getAvailableRecipients();
            let { recipientList: availableRecipients, centerList: availableRecipientCenterList } = availableRecipientResponse.results;
            let response = await this.props.getSwapsByChainId(chainId);
            let positions = response.data.results.flatMap(x => x.positions);//.map((position, index) => ({ ...position, index, highlight: false, isNotCurrent: true }));

            let notification: IAdminNotification = null;

            if (notificationId > 0) {
                let notificationResponse = await this.props.getNotification(notificationId);
                notification = notificationResponse.data.results;
            }

            this.setState({
                chainId,
                clusterNumber,
                positionNumber,
                availableRecipients,
                availableRecipientCenterList,
                positions,
                notification
            }, () => {
                this.props.hideLoading();
            });
        });
    }

    updateSwaps = (message: string, success: boolean) => {
        this.props.showLoading('Getting chain information, one moment please...').then(async () => {
            let availableRecipientResponse = await this.props.getAvailableRecipients();
            let { recipientList: availableRecipients, centerList: availableRecipientCenterList } = availableRecipientResponse.results;
            let response = await this.props.getSwapsByChainId(this.state.chainId);
            let positions = response.data.results.flatMap(x => x.positions).map((position, index) => ({ ...position, index, highlight: false, isNotCurrent: true }));

            this.setState({
                availableRecipients,
                availableRecipientCenterList,
                positions
            }, () => {
                if (success) {
                    toast.success(message);
                } else {
                    toast.error(message);
                }
            })
        });
    }

    handleAction = (action: SwapManagementAction, clusterForAction: number, positionForAction: number, donorForAction: number, recipientForAction: number, replacementRecipientId: number, bridgeDonorId: number) => {
        let chainId = this.state.chainId;

        if (action == SwapManagementAction.Bridge) {
            this.props.showLoading('Bridging donor, one moment please...').then(() => {
                this.props.bridgeDonor(donorForAction, chainId)
                    .then(async response => {
                        if (response.data.success) {
                            this.updateSwaps('Donor bridged successfully', true);
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.Unbridge) {
            this.props.showLoading('Unbridging donor, one moment please...').then(() => {
                this.props.unBridgeDonor(donorForAction, chainId)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Donor unbridged successfully', true);
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.NewChainAsVoucher) {
            this.props.showLoading('Creating new voucher chain, one moment please...').then(() => {
                this.props.convertToVoucher(donorForAction, chainId, null)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('New voucher chain created successfully', true);
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.ResetCluster) {
            this.props.showLoading('Cancelling cluster, one moment please...').then(() => {
                this.props.cancelCluster(clusterForAction, donorForAction)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Cluster cancelled successfully', true);
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.RemoveRecipient) {
            this.props.showLoading('Removing recipient from cluster, one moment please...').then(() => {
                this.props.removeRecipientFromCluster(clusterForAction, recipientForAction)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Recipient removed from cluster successfully', true);
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.RemovePair) {
            this.props.showLoading('Removing pair, one moment please...').then(() => {
                this.props.removePairFromCluster(clusterForAction, positionForAction, recipientForAction, donorForAction)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Pair removed successfully', true);
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.ReplaceRecipient) {
            this.props.showLoading('Replacing recipient, one moment please...').then(() => {
                this.props.replaceRecipientInCluster(clusterForAction, recipientForAction, replacementRecipientId, bridgeDonorId)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Recipient replaced successfully', true);
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.ReplacePair) {
            this.props.showLoading('Replacing pair, one moment please...').then(() => {
                this.props.replacePairInCluster(clusterForAction, donorForAction, replacementRecipientId, bridgeDonorId)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Pair replaced successfully', true);
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }

        if (action == SwapManagementAction.AddRecipient) {
            this.props.showLoading('Adding recipient, one moment please...').then(() => {
                this.props.addRecipientToCluster(clusterForAction, positionForAction, replacementRecipientId, bridgeDonorId)
                    .then(response => {
                        if (response.data.success) {
                            this.updateSwaps('Recipient added successfully', true);
                        }
                    })
                    .catch(error => {
                        toast.error(error.response.data, { autoClose: false });

                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }
    }

    render = () => {
        const notification = this.state.notification;

        return (
            <div className='container' style={{ marginTop: 30 }}>
                <div style={{ fontSize: 28, fontWeight: 500, marginBottom: 20 }}>
                    <>SWAP TOOLBOX for Chain {this.state.chainId}</>
                </div>

                {notification != null && (
                    <Well>
                        <h4 style={{ marginTop: 0 }}>Center Request</h4>
                        <Row>
                            <Col xs={12} lg={2}>Type:</Col>
                            <Col xs={12} lg={10}>{notification.description}</Col>

                            <Col xs={12} lg={2}>Current Recipient:</Col>
                            <Col xs={12} lg={10}>{notification.additionalData.originalRecipientAlias} @ {notification.additionalData.originalRecipientCenter}</Col>

                            <Col xs={12} lg={2}>Replacement Recipient:</Col>
                            <Col xs={12} lg={10}>{notification.additionalData.replacementRecipientAlias} @ {notification.additionalData.replacementRecipientCenter}</Col>

                            <Col xs={12} lg={2}>Bridge Donor:</Col>
                            <Col xs={12} lg={10}>{notification.additionalData.bridgeDonorAlias} @ {notification.additionalData.bridgeDonorCenter}</Col>

                            <Col xs={12} lg={2}>Requested:</Col>
                            <Col xs={12} lg={10}>{notification.addedDateTime}</Col>
                        </Row>
                    </Well>
                )}

                <SwapManagement
                    show={true}
                    chainId={this.state.chainId}
                    positions={this.state.positions}
                    recipientList={this.state.availableRecipients}
                    centerList={this.state.availableRecipientCenterList}
                    isStandalone={true}
                    onAction={this.handleAction}
                    onClose={() => null} />
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getSwapsByChainId: (chainId) => {
            return dispatch(SwapActionCreators.getSwapsByChainId(chainId));
        },
        getAvailableRecipients: () => {
            return dispatch(SwapActionCreators.getAvailableRecipients());
        },
        getNotification: (id) => {
            return dispatch(AdminActionCenterActionCreators.getNotification(id));
        },
        bridgeDonor: (donorId, chainId) => {
            return dispatch(SwapActionCreators.bridgeDonor(donorId, chainId));
        },
        unBridgeDonor: (donorId, chainId) => {
            return dispatch(SwapActionCreators.unBridgeDonor(donorId, chainId));
        },
        convertToVoucher: (donorId, originalChainId, newChainId) => {
            return dispatch(SwapActionCreators.convertToVoucher(donorId, originalChainId, newChainId));
        },
        cancelCluster: (clusterId, firstDonorId) => {
            return dispatch(SwapActionCreators.cancelCluster(clusterId, firstDonorId));
        },
        removeRecipientFromCluster: (clusterId, recipientId) => {
            return dispatch(SwapActionCreators.removeRecipientFromCluster(clusterId, recipientId));
        },
        removePairFromCluster: (clusterId, positionNumber, recipientId, bridgeDonorId) => {
            return dispatch(SwapActionCreators.removePairFromCluster(clusterId, positionNumber, recipientId, bridgeDonorId));
        },
        replaceRecipientInCluster: (clusterId, recipientId, replacementRecipientId, bridgeDonorId) => {
            return dispatch(SwapActionCreators.replaceRecipientInCluster(clusterId, recipientId, replacementRecipientId, bridgeDonorId));
        },
        replacePairInCluster: (clusterId, currentBridgeDonorId, replacementRecipientId, bridgeDonorId) => {
            return dispatch(SwapActionCreators.replacePairInCluster(clusterId, currentBridgeDonorId, replacementRecipientId, bridgeDonorId));
        },
        addRecipientToCluster: (clusterId, positionNumber, recipientId, bridgeDonorId) => {
            return dispatch(SwapActionCreators.addRecipientToCluster(clusterId, positionNumber, recipientId, bridgeDonorId));
        },
    };
}

export default connect<{}, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(SwapManagementPage);